import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import React, { useState, useEffect } from 'react';
import NavBar from '../components/NavBar';
import { FaMapMarkerAlt, FaClock, FaCalendar } from 'react-icons/fa';
import { LuMapPin } from 'react-icons/lu';
import { requestEvents } from '../services/requests';
import { use } from 'react';

const monthNames = [
	'Janeiro',
	'Fevereiro',
	'Março',
	'Abril',
	'Maio',
	'Junho',
	'Julho',
	'Agosto',
	'Setembro',
	'Outubro',
	'Novembro',
	'Dezembro',
];

/* const eventsData = [
	{
		id: 1,
		titulo: 'Luta Contra a Aids',
		descricao: 'Dia Mundial de Luta Contra a Aids',
		categoria: 'Conferencia',
		categoria_display: 'Conferência',
		local: 'Centro Administrativo Municipal São Sebastião',
		data: '2024-12-01',
		horario: '00:00',
	},
	{
		id: 2,
		titulo: 'Dia Pan-Americano de Saúde',
		descricao: 'Dia Pan-Americano de Saúde',
		categoria: 'Palestra',
		categoria_display: 'Palestra',
		local: 'Centro Administrativo Municipal São Sebastião',
		data: '2024-12-02',
		horario: '00:00',
	},
	{
		id: 3,
		titulo: 'Luta das Pessoas com Deficiência',
		descricao: 'Dia Internacional de Luta das Pessoas com Deficiência',
		categoria: 'Palestra',
		categoria_display: 'Palestra',
		local: 'Centro Administrativo Municipal São Sebastião',
		data: '2024-12-03',
		horario: '00:00',
	},
	{
		id: 4,
		titulo: 'Dia do Fonoaudiólogo',
		descricao: 'Palestra Sobre Dia do Fonoaudiólogo',
		categoria: 'Palestra',
		categoria_display: 'Palestra',
		local: 'Centro Administrativo Municipal São Sebastião',
		data: '2024-12-09',
		horario: '00:00',
	},
	{
		id: 5,
		titulo: 'Dia da Criança com Deficiência',
		descricao: 'Dia da Criança com Deficiência',
		categoria: 'Palestra',
		categoria_display: 'Palestra',
		local: 'Centro Administrativo Municipal São Sebastião',
		data: '2024-12-09',
		horario: '00:00',
	},
	{
		id: 6,
		titulo: 'Dia Internacional dos Direitos Humanos',
		descricao: 'Dia Internacional dos Direitos Humanos',
		categoria: 'Palestra',
		categoria_display: 'Palestra',
		local: 'Centro Administrativo Municipal São Sebastião',
		data: '2024-12-10',
		horario: '00:00',
	},
	{
		id: 7,
		titulo: 'Inicio do Verão',
		descricao: 'Protocolo para o Inicio do Verão',
		categoria: 'Palestra',
		categoria_display: 'Palestra',
		local: 'Centro Administrativo Municipal São Sebastião',
		data: '2024-12-21',
		horario: '00:00',
	},
	{
		id: 8,
		titulo: 'Dia Internacional da Biodiversidade',
		descricao: 'Dia Internacional da Biodiversidade',
		categoria: 'Conferencia',
		categoria_display: 'Conferência',
		local: 'Centro Administrativo Municipal São Sebastião',
		data: '2024-12-29',
		horario: '00:00',
	},
]; */

function Agenda() {
	const [currentDate, setCurrentDate] = useState(new Date());
	const [selectedCategory, setSelectedCategory] = useState('Todos');
	const [eventsData, setEventsData] = useState([]);
	const [filters, setFilters] = useState([]);

	const handleNextMonth = () => {
		setCurrentDate((prevDate) => {
			const nextDate = new Date(prevDate);
			nextDate.setMonth(nextDate.getMonth() + 1);
			return nextDate;
		});
	};

	const handlePreviousMonth = () => {
		setCurrentDate((prevDate) => {
			const previousDate = new Date(prevDate);
			previousDate.setMonth(previousDate.getMonth() - 1);
			return previousDate;
		});
	};

	const month = monthNames[currentDate.getMonth()];
	const year = currentDate.getFullYear();

	const filteredEvents = eventsData.filter((event) => {
		const eventDate = new Date(`${event.data}T12:00:00`);
		const isSameMonth =
			eventDate.getMonth() === currentDate.getMonth() &&
			eventDate.getFullYear() === currentDate.getFullYear();
		const isCategoryMatch =
			selectedCategory === 'Todos' ||
			event.categoria === selectedCategory;

		return isSameMonth && isCategoryMatch;
	});

	useEffect(() => {
		requestEvents().then((data) => {
			let fit = [];
			if (!data.error) {
				data.forEach((event) => {
					if (!fit.includes(event.categoria)) {
						fit.push(event.categoria);
					}
				});
				setFilters(fit);
				setEventsData(data);
			} else {
				console.log('Erro ao carregar eventos');
			}
		});
	}, []);

	return (
		<div className='flex flex-col min-h-screen'>
			<NavBar />
			<h1 className='text-[#004A80] bg-[#F0F4F8] p-12 font-semibold flex items-center justify-center text-3xl md:text-[38px] font-roboto mt-[80px] '>
				Eventos SUBHUE
			</h1>
			<div className=' text-center font-inter flex-grow mx-auto w-[90%] max-w-[1136px]  '>
				{/* Carrossel */}
				<div className=' h-28 rounded-md flex items-center justify-center px-4 '>
					<button
						type='button'
						onClick={handlePreviousMonth}
						className=' w-[2rem] scale-125 font-medium rounded-md text-sm transition duration-300 text-[#004A80] ease-in-out hover:scale-150 p-2'>
						<IoIosArrowBack className='scale-150' />
					</button>
					<div className='grid place-items-center mx-5 md:mx-10 h-full font-bold text-lg md:text-[25px] text-[#004A80]'>
						{month} de {year}
					</div>
					<button
						type='button'
						onClick={handleNextMonth}
						className=' w-[2rem] font-medium rounded-md text-sm transition duration-300 text-[#004A80] ease-in-out scale-125 hover:scale-150 p-2'>
						<IoIosArrowForward className='scale-150' />
					</button>
				</div>
				<div className='flex justify-center'>
					<div className='flex flex-wrap justify-center my-8 w-full md:w-[60%] gap-4'>
						{['Todos', ...filters].map((category, index) => (
							<button
								key={index + 'faf'}
								onClick={() => setSelectedCategory(category)}
								className={` h-10 rounded-md ${
									selectedCategory === category
										? 'bg-[#4dc6ff]'
										: 'bg-[#004A80]'
								} hover:bg-[#4dc6ff] text-white font-semibold transition duration-200 w-[200px] ease-in-out`}>
								{category}
							</button>
						))}
					</div>
				</div>
				<div className='flex flex-wrap justify-center gap-5 gap-y-10 my-10'>
					{filteredEvents.map((event, index) => (
						<div
							key={index + 'corn'}
							className='w-full max-w-xs sm:w-[300px] border-[1px] border-[#004A80] rounded-md shadow-xl bg-slate-50 overflow-hidden flex flex-col'>
							<div className='flex flex-grow justify-start px-2 place-items-center min-h-[40px] text-white font-bold text-md w-full rounded-sm rounded-b-none bg-[#004A80]'>
								{event.categoria}
							</div>
							<div className='p-2 h-full flex flex-col justify-between flex-grow'>
								<div className='text-start py-4 font-medium text-[16px] text-[#757575] overflow-hidden'>
									{event.titulo}
								</div>
								<div>
									<div className='w-full flex h-[100px] text-center flex-shrink-0'>
										<div className='w-[15%] mr-2 my-auto'>
											<div className='text-[#004A80] text-center'>
												<div className='text-[20px]'>
													{(() => {
														const [ano, mes, dia] =
															event.data.split(
																'-'
															);
														return monthNames[
															parseInt(mes, 10) -
																1
														].slice(0, 3);
													})()}
												</div>
												<div className='text-[33px] leading-tight font-normal'>
													{(() => {
														const [_, __, dia] =
															event.data.split(
																'-'
															);
														return dia;
													})()}
												</div>
											</div>
											<div className='text-[13px] text-[#757575]'>
												{event.horario.slice(0, 5)}h
											</div>
										</div>
										<div className='w-[1px] h-[60%] bg-[#D9D9D9] my-auto'></div>
										<div className='text-[#757575] w-[80%] font-normal content-center text-start text-[14px] px-2'>
											{event.descricao}
										</div>
									</div>

									<div className='text-[#757575] flex text-start mt-2'>
										<div className='h-full my-auto mr-1 text-[#004A80]'>
											<LuMapPin />
										</div>
										<div className='text-[12px] font-normal'>
											{event.local}
										</div>
									</div>
								</div>
							</div>
						</div>
					))}
				</div>
			</div>
		</div>
	);
}

export default Agenda;
